var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      { staticClass: "post-embed", attrs: { href: _vm.url, target: "_blank" } },
      [
        _c("div", {
          staticClass: "embed-img",
          style: { "background-image": "url(" + _vm.img_src + ")" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "embed-cont" }, [
          _c("div", { staticClass: "embed-provider" }, [
            _vm._v(_vm._s(_vm.provider))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "embed-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "embed-description" }, [
            _vm._v(_vm._s(_vm.description))
          ]),
          _vm._v(" "),
          _vm.with_delete_btn
            ? _c(
                "div",
                {
                  staticClass: "embed-clear",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.$emit("delete")
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "https://enklav-production.s3.amazonaws.com/uploads/image/circle-x-black.svg"
                    }
                  })
                ]
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }